import { MainPadding } from "../../../styles/Main.styles";
import { useState } from "react";
import TableHeader from "../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import { useGetProducts } from "../api/product/resolver";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { IconOnButton } from "../../../components/button/Button";
import TableHeaderExtra, {
  MainFilterGroup,
} from "../__component/tableHeaderExtra/TableHeaderExra";
import { useForm } from "react-hook-form";
import { Typography } from "@mui/material";

export default function Main() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { control, watch, setValue } = useForm<MainFilterGroup>();
  const { data: dataRawProducts, isLoading: loadingFetchProducts } =
    useGetProducts({
      keyword,
      page,
      perPage,
      has_tax: watch("has_tax"),
      max_price: watch("max_price"),
      min_price: watch("min_price"),
      product_brand_id: watch("product_brand_id"),
      product_category_id: watch("product_category_id"),
      stock: watch("stock"),
    });
  const dataProducts = dataRawProducts?.data?.data?.data;
  const { renderRight, renderFilter } = TableHeaderExtra();
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama" },
    { title: "Satuan" },
    { title: "Harga" },
    { title: "Stock" },
    { title: "Pajak" },
  ];
  const bodyTable: TableFCBodyProps[] = [
    {
      key: "",
      component: (item) => (
        <Typography onClick={() => navigate(`/produk/creation/${item.id}`)}>
          {item.product_category.category_name} -{" "}
          {item.product_brand.brand_name} - {item.product_type_name}
        </Typography>
      ),
    },
    { key: "unit_type" },
    { key: "price", isMoney: true },
    { key: "stock" },
    {
      key: "has_tax",
      isMap: [
        { from: 1, to: "Ya" },
        { from: -1, to: "Tidak" },
      ],
    },
  ];

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search Produk"
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/produk/creation")}
        renderFilter={renderFilter({ control, setValue })}
        renderRight={renderRight()}
        renderRightButton={
          <IconOnButton
            text="Import/Export"
            icon={<ImportExportIcon />}
            handleClick={() => {}}
          />
        }
      />
      <TableFC
        loading={loadingFetchProducts}
        data={dataProducts}
        body={bodyTable}
        showIndex
        totalRows={dataRawProducts?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/produk/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
